<mpro-loading *ngIf="dataService.getIsLoading() | async"></mpro-loading>
<div>
  <span *ngIf="!isFreemium" class="header">
    Consumer {{ dataFilters.spendingGroup.type }}</span
  >
  <span *ngIf="isFreemium" class="header"> Future Consumer Demand</span>
  <p class="sub-header">
    {{ dataFilters.regionSelection.getName() }} - {{ dataFilters.year }}
  </p>
  <mpro-tags style="margin: 15px 0px"></mpro-tags>
  <ng-container>
    <mpro-info-box
      [left]="totalPeopleBox"
      [right]="totalSpendingIncomeBox"
      [color]="getInfoBoxTextColor()"
    ></mpro-info-box>
    <mpro-info-box
      [left]="totalSpendingIncomePerCapitaBox"
      [right]="largerThanAvgBox"
      [color]="getInfoBoxTextColor()"
    ></mpro-info-box>
  </ng-container>
  <!-- line -->
  <hr />
  <p class="margin">Annual Market growth</p>
  <div class="dropdown-div">
    <div>
      <button class="openButton" (click)="changeStartYearOpen()">
        {{ startYear }}<fa-icon [icon]="faCaretDown"></fa-icon>
      </button>
      <div class="dropdown" *ngIf="startYearOpen">
        <button
          *ngFor="let year of startYears"
          (click)="setStartYear(year, true)"
          blockOnClickEvent
          [condition]="yearCondition(year)"
          [callback]="authService.openFreemiumRequestModal"
        >
          {{ year }}
          <fa-icon
          *ngIf="yearCondition(year)"
          [icon]="faLock"
          class="lock"
        ></fa-icon>
        </button>
      </div>
    </div>
    <p class="to">to</p>
    <div>
      <button class="openButton" (click)="changeEndYearOpen()">
        {{ endYear }}<fa-icon [icon]="faCaretDown"></fa-icon>
      </button>
      <div class="dropdown" *ngIf="endYearOpen">
        <button *ngFor="let year of endYears"  (click)="setEndYear(year, true)"
                blockOnClickEvent
                [condition]="yearCondition(year)"
                [callback]="authService.openFreemiumRequestModal"
        >
          {{ year }}
          <fa-icon
            *ngIf="yearCondition(year)"
            [icon]="faLock"
            class="lock"
          ></fa-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="info-div three" *ngIf="!loadingCitiyConsumerSpending">
    <div>
      <p class="subtitle">People</p>
      <p
        *ngIf="peopleGrowth !== null"
        class="title blue"
        [class.red]="peopleGrowth < 0"
        [class.green]="peopleGrowth > 0"
      >
        {{ peopleGrowth > 0 ? "+" : "" }}{{ peopleGrowth | formatNumber }}%
      </p>
    </div>
    <div>
      <p class="subtitle">{{ this.dataFilters.spendingGroup.type }}</p>
      <p
        *ngIf="spendingGrowth !== null"
        class="title blue"
        [class.red]="spendingGrowth < 0"
        [class.green]="spendingGrowth > 0"
      >
        {{ spendingGrowth > 0 ? "+" : "" }}{{ spendingGrowth | formatNumber }}%
      </p>
    </div>
    <div>
      <p class="subtitle">
        {{ this.dataFilters.spendingGroup.type }} per capita
      </p>
      <p
        *ngIf="spendingPerCapitaGrowth !== null"
        class="title blue"
        [class.red]="spendingPerCapitaGrowth < 0"
        [class.green]="spendingPerCapitaGrowth > 0"
      >
        {{ spendingPerCapitaGrowth > 0 ? "+" : ""
        }}{{ spendingPerCapitaGrowth | formatNumber }}%
      </p>
    </div>
  </div>
  <ng-container *ngIf="loadingCitiyConsumerSpending">
    <mpro-loading></mpro-loading>
  </ng-container>
</div>
